export default {
  title: 'Functievlaggen',
  subtitle: 'Schakel platformfuncties in of uit voor {{company}}.',
  no_company: 'Selecteer een restaurant om de functievlaggen te beheren.',
  columns: {
    feature: 'Functie',
    status: 'Status',
  },
  flags: {
    paypal_standalone: {
      name: 'PayPal (direct)',
      description:
        'Laat dit restaurant PayPal-betalingen rechtstreeks op hun eigen PayPal-account ontvangen. Standaard ingeschakeld voor restaurants van partners die door Foodamigos worden gefactureerd, waarbij de servicekosten voor klanten ook over deze betalingen worden geheven en het aandeel van het platform aan de partner wordt gefactureerd.',
    },
    vip_free_flyers: {
      name: 'Maandelijkse gratis flyers',
      description:
        'Stuur automatisch 500 promotionele flyers per maand naar dit restaurant (standaard: aan voor VIP en Star-niveau).',
    },
    custom_store_seo: {
      name: 'Aangepaste winkel-SEO',
      description: 'Laat dit restaurant de aangepaste SEO-instellingen voor hun webshop beheren.',
    },
    external_printer: {
      name: 'Externe bonprinter',
      description:
        'Laat dit restaurant een netwerkbonprinter verbinden met de bestelterminalapp, in plaats van afdrukken op de ingebouwde printer van de terminal.',
    },
    stripe_payment_element: {
      name: 'Stripe Payment Element-afrekenen',
      description:
        'Laat het eigen Stripe-account van het restaurant bepalen welke betaalmethoden bij het afrekenen worden aangeboden. Schakel dit pas in zodra het Stripe-platform de betaalmethoden voor verbonden accounts heeft ingesteld.',
    },
  },
  toasts: {
    enabled: 'Functie ingeschakeld.',
    disabled: 'Functie uitgeschakeld.',
    error: 'Kon de functie niet bijwerken. Probeer het opnieuw.',
    load_error: 'Kon functievlaggen niet laden.',
  },
};
